module.exports = "/packs/images/svg/alert-low~0e1cf6bfdafe845ca812032cb9fa74c4.svg";